export const DROPDOWN_GROUPS = {
  DAILY_CATEGORY: 'DailyCategory',
  INCOME_CATEGORY: 'IncomeCategory',
  INVESTMENT_CATEGORY: 'InvestmentCategory',
  PLAN_CATEGORY: 'PlanCategory',
  PAYMENT_MODE: 'PaymentMode',
  CRDR_TYPE: 'CrDrType',
  PLAN_FREQUENCY: 'PlanFrequency',
  FLOW: 'Flow',
  TAX_TAG: 'TaxTag'
} as const;

export type DropdownGroup = typeof DROPDOWN_GROUPS[keyof typeof DROPDOWN_GROUPS];

export const DROPDOWN_GROUP_OPTIONS = Object.values(DROPDOWN_GROUPS);

export const DEFAULT_DROPDOWNS: Record<DropdownGroup, string[]> = {
  DailyCategory: ['Food', 'Travel', 'Shopping', 'Other'],
  IncomeCategory: ['Salary', 'Business', 'Other Income'],
  InvestmentCategory: ['SIP', 'FD', 'Gold', 'Stock'],
  PlanCategory: ['EMI', 'SIP', 'Maintenance', 'Subscription', 'Future Expense'],
  PaymentMode: ['UPI', 'Cash', 'Card', 'Bank'],
  CrDrType: ['CR', 'DR'],
  PlanFrequency: ['One Time', 'Weekly', 'Monthly', 'Quarterly', 'Half Yearly', 'Yearly'],
  Flow: ['Expense', 'Income', 'Investment'],
  TaxTag: ['Salary Income', 'Freelance Income', 'Business Income', 'Business Expense', 'Personal Expense', 'Investment', 'Insurance', 'Medical', 'Education', 'Rent', 'Donation', 'Loan EMI', 'Credit Card Payment', 'Transfer', 'Ignore for ITR']
};

export const normalizeDropdownValue = (value: string) => value.trim().replace(/\s+/g, ' ').toLowerCase();

export const defaultDropdownValue = (group: DropdownGroup) => DEFAULT_DROPDOWNS[group][0] || '';

export const dropdownOptions = (grouped: Partial<Record<DropdownGroup, string[]>>, group: DropdownGroup) =>
  grouped[group]?.length ? grouped[group] : DEFAULT_DROPDOWNS[group];
